import React, { useEffect, useState } from 'react';
import {
  ComposedChart,
  Bar,
  XAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  YAxis,
} from 'recharts';
import PropTypes from 'prop-types';
import { getImportExportDocuments } from '../../../services/adminDashboard';

const originalUploadData = [
  { name: 'LocalDevice', LocalDevice: 0 },
  { name: 'Gmail', Gmail: 0 },
  { name: 'GoogleDrive', GoogleDrive: 0 },
  { name: 'Outlook', Outlook: 0 },
  { name: 'Sharepoint', Sharepoint: 0 },
  { name: 'OneDrive', OneDrive: 0 },
];

const originalExportData = [
  { name: 'Odoo', Odoo: 0 },
  { name: 'TallyPrime', TallyPrime: 0 },
  { name: 'Zoho', Zoho: 0 },
  { name: 'Xero', Xero: 0 },
  { name: 'QuickBook', QuickBook: 0 },
  { name: 'Pdf', Pdf: 0 },
  { name: 'Xml', Xml: 0 },
  { name: 'Excel', Excel: 0 },
  { name: 'Json', Json: 0 },
];

const UploadExportHistoryBarChart = ({
  mainKey,
  itemName,
  selectedDashboardType,
  filteredTypes,
  getTypeByTitle,
}) => {
  const [uploadData, setUploadData] = useState(originalUploadData);
  const [exportData, setExportData] = useState(originalExportData);

  const getUsersCountData = async () => {
    const typePayloadArr =
      selectedDashboardType === 'compare'
        ? getTypeByTitle(itemName)
        : filteredTypes;

    const response = await getImportExportDocuments(typePayloadArr);
    if (response && Object.keys(response?.data?.stages)?.length > 0) {
      const finalData = response.data.stages;
      setUploadData([
        {
          name: 'LocalDevice',
          LocalDevice: finalData?.importResult?.localdeviceImport || 0,
        },
        { name: 'Gmail', Gmail: finalData?.importResult?.gmailImport || 0 },
        {
          name: 'GoogleDrive',
          GoogleDrive: finalData?.importResult?.googledriveImport || 0,
        },
        {
          name: 'Outlook',
          Outlook: finalData?.importResult?.outlookImport || 0,
        },
        {
          name: 'Sharepoint',
          Sharepoint: finalData?.importResult?.sharepointImport || 0,
        },
        {
          name: 'OneDrive',
          OneDrive: finalData?.importResult?.onedriveImport || 0,
        },
      ]);

      setExportData([
        { name: 'Odoo', Odoo: finalData?.exportResult?.odooExport || 0 },
        {
          name: 'TallyPrime',
          TallyPrime: finalData?.exportResult?.tallyprimeExport || 0,
        },
        { name: 'Zoho', Zoho: finalData?.exportResult?.zohoExport || 0 },
        { name: 'Xero', Xero: finalData?.exportResult?.xeroExport || 0 },
        {
          name: 'QuickBook',
          QuickBook: finalData?.exportResult?.quickbookExport || 0,
        },
        { name: 'Pdf', Pdf: finalData?.exportResult?.pdfExport || 0 },
        { name: 'Xml', Xml: finalData?.exportResult?.xmlExport || 0 },
        { name: 'Excel', Excel: finalData?.exportResult?.excelExport || 0 },
        { name: 'Json', Json: finalData?.exportResult?.jsonExport || 0 },
      ]);
    } else {
      setUploadData([]);
      setExportData([]);
    }
  };

  useEffect(() => {
    getUsersCountData();
  }, [filteredTypes]);

  const data = mainKey === 'Upload' ? uploadData : exportData;

  const tooltipFormatter = (value) => {
    let displayValue = value;
    if (mainKey === 'Upload') {
      displayValue += ' Document Import';
    } else {
      displayValue += ' Document Export';
    }
    return [displayValue, null];
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart data={data} width={100} barCategoryGap="0%">
        <CartesianGrid
          stroke="rgba(46, 37, 89, 0.1)"
          strokeDasharray="none"
          vertical={false}
          horizontal
        />
        <XAxis
          dataKey="name"
          tickLine={false}
          axisLine={false}
          tick={{
            fill: 'rgba(46, 37, 89, 0.6)',
            fontSize: 10,
            fontWeight: '400',
          }}
        />
        <YAxis
          width={30}
          tickLine={false}
          axisLine={false}
          tick={{
            fill: 'rgba(46, 37, 89, 0.6)',
            fontSize: 12,
            fontWeight: '400',
          }}
          domain={[0, 'dataMax']}
        />
        <Tooltip
          formatter={tooltipFormatter}
          contentStyle={{
            backgroundColor: 'rgba(46, 37, 89, 1)',
            color: 'rgba(255, 255, 255, 1)',
            borderRadius: '5px',
            padding: '10px',
          }}
          labelStyle={{ display: 'none' }}
          itemStyle={{ color: 'rgba(255, 255, 255, 1)' }}
        />

        {mainKey === 'Upload' ? (
          <>
            <Bar
              stackId="a"
              dataKey="LocalDevice"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Outlook"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Sharepoint"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="OneDrive"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Gmail"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="GoogleDrive"
              fill="rgba(185, 150, 252, 1)"
              barSize={40}
              radius={5}
            />
          </>
        ) : (
          <>
            <Bar
              stackId="a"
              dataKey="Odoo"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Zoho"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="QuickBook"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="TallyPrime"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Xero"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Pdf"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Xml"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Excel"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
            <Bar
              stackId="a"
              dataKey="Json"
              fill="rgba(185, 150, 252, 1)"
              barSize={30}
              radius={5}
            />
          </>
        )}
      </ComposedChart>
    </ResponsiveContainer>
  );
};

UploadExportHistoryBarChart.defaultProps = {
  itemName: '',
  filteredTypes: [],
  getTypeByTitle: null,
};

UploadExportHistoryBarChart.propTypes = {
  mainKey: PropTypes.string.isRequired,
  itemName: PropTypes.string,
  selectedDashboardType: PropTypes.string.isRequired,
  filteredTypes: PropTypes.arrayOf(),
  getTypeByTitle: PropTypes.func,
};
export default UploadExportHistoryBarChart;
